import { Table } from "react-bootstrap";
import "../../../../common/styles/table.css";
import QuestDetailTableRow from "./QuestDetailTableRow";

/**
 * @typedef {import("../../../../hooks/teacher/students/useGetStudentReportByQuestId").EpisodeInfo} EpisodeInfo
 */

/**
 * Quest Detail Table Component
 * @param {{episodes: EpisodeInfo[]}} props
 */
const QuestDetailTable = ({ episodes }) => {
  if (!episodes || episodes.length === 0) {
    return (
      <div className="alert alert-info mt-3" role="alert">
        No episodes found.
      </div>
    );
  }

  return (
    <div className="custom-table-container mt-3">
      <div className="custom-table-wrapper">
        <Table hover className="custom-table">
          <thead className="custom-table-head">
            <tr>
              <th>Episode</th>
              <th>Best Score</th>
              <th>Attempts</th>
            </tr>
          </thead>
          <tbody>
            {episodes.map((episode, index) => {
              return (
                <QuestDetailTableRow key={episode.episode || index} episode={episode} />
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default QuestDetailTable;
